import React from 'react';
import { useWeb3 } from '../contexts/Web3Context';
import { Plus, Minus } from 'lucide-react';
import { toast } from 'sonner';

const Liquidity = () => {
  const { account } = useWeb3();

  const handleAddLiquidity = () => {
    if (!account) {
      toast.error('Please connect your wallet first');
      return;
    }
    toast.info('Add liquidity feature coming soon');
  };

  return (
    <div data-testid="liquidity-page" className="min-h-screen py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-3">Liquidity Pools</h1>
          <p className="text-white/60 text-lg">Provide liquidity and earn trading fees</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          <div className="bg-black/40 backdrop-blur-xl border border-white/10 rounded-2xl p-8 hover:border-white/20 hover:bg-white/5 transition-all duration-300">
            <div className="w-12 h-12 bg-primary/20 rounded-xl flex items-center justify-center mb-4">
              <Plus className="w-6 h-6 text-primary" />
            </div>
            <h3 className="text-2xl font-semibold text-white mb-2">Add Liquidity</h3>
            <p className="text-white/60 mb-6">Provide equal values of two tokens to the pool</p>
            <button
              onClick={handleAddLiquidity}
              data-testid="add-liquidity-btn"
              className="w-full bg-primary hover:bg-primary/90 text-white font-medium py-3 rounded-full transition-all hover:scale-105 active:scale-95"
            >
              Add Liquidity
            </button>
          </div>

          <div className="bg-black/40 backdrop-blur-xl border border-white/10 rounded-2xl p-8 hover:border-white/20 hover:bg-white/5 transition-all duration-300">
            <div className="w-12 h-12 bg-red-500/20 rounded-xl flex items-center justify-center mb-4">
              <Minus className="w-6 h-6 text-red-500" />
            </div>
            <h3 className="text-2xl font-semibold text-white mb-2">Remove Liquidity</h3>
            <p className="text-white/60 mb-6">Withdraw your tokens and earned fees</p>
            <button
              data-testid="remove-liquidity-btn"
              className="w-full bg-white/5 hover:bg-white/10 text-white border border-white/10 font-medium py-3 rounded-full transition-all"
            >
              Remove Liquidity
            </button>
          </div>
        </div>

        <div className="bg-black/40 backdrop-blur-xl border border-white/10 rounded-2xl p-8">
          <h2 className="text-2xl font-semibold text-white mb-6">Your Liquidity Positions</h2>
          
          {!account ? (
            <div className="text-center py-12">
              <p className="text-white/60 mb-4">Connect your wallet to view your positions</p>
            </div>
          ) : (
            <div className="text-center py-12">
              <p className="text-white/60 mb-4">No liquidity positions found</p>
              <button
                onClick={handleAddLiquidity}
                className="inline-flex items-center gap-2 bg-primary hover:bg-primary/90 text-white font-medium px-6 py-3 rounded-full transition-all"
              >
                <Plus className="w-4 h-4" />
                Add Your First Position
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Liquidity;